import clsx from "clsx";
import type { FC, ReactElement } from "react";
import { Link, useLocation } from "react-router-dom";

import { AppText, TEXT_VARIANTS_VARIABLES } from "@/ui/app-text";

import { ROUTERS } from "@/shared/constants/routers";
import { TEXT } from "@/shared/constants/text";
import { isMobileDevice } from "@/shared/lib/is-mobile-device";

import CardCoinSvg from "@/assets/icons/cardCoin.svg";
import ClipboardTextSvg from "@/assets/icons/clipboardText.svg";
import ProfileCircleSvg from "@/assets/icons/profileCircle.svg";

interface Props {
  className?: string;
}

const navs: {
  icon: ReactElement;
  text: string;
  href: string;
  childrenRoutes?: string[];
  hightlightPaths: string[];
}[] = [
  {
    icon: <ClipboardTextSvg />,
    text: TEXT.navbar.history,
    hightlightPaths: [ROUTERS.HISTORY],
    href: ROUTERS.HISTORY,
  },
  {
    icon: <CardCoinSvg />,
    text: TEXT.navbar.exchange,
    hightlightPaths: [ROUTERS.MAIN],
    href: ROUTERS.MAIN,
    childrenRoutes: [ROUTERS.VERIFICATION],
  },
  {
    icon: <ProfileCircleSvg />,
    text: TEXT.navbar.profile,
    hightlightPaths: [ROUTERS.PROFILE, ROUTERS.FAQ],
    href: ROUTERS.PROFILE,
  },
];

const isHighlight = (highlightPaths: string[], href: string) => {
  return highlightPaths.includes(href);
};

export const Navbar: FC<Props> = ({ className }) => {
  const location = useLocation();
  const isMobile = isMobileDevice();
  return (
    <nav
      className={clsx(
        className,
        "fixed bottom-0 left-1/2 flex w-full max-w-(--maxWidth) -translate-x-1/2 bg-(--black-bg) px-3 py-3",
        isMobile && "pb-10",
      )}
    >
      <ul className="flex w-full justify-around">
        {navs.map((item, index) => (
          <li
            key={index}
            className={clsx(
              location.pathname === item.href ||
                item.childrenRoutes?.includes(location.pathname) ||
                isHighlight(item.hightlightPaths, location.pathname)
                ? "text-text-secondary"
                : "text-text-tertiary",
            )}
          >
            <Link
              to={item.href}
              className="flex flex-col items-center justify-center gap-1.5"
            >
              {item.icon}
              <AppText
                variant={TEXT_VARIANTS_VARIABLES.tertiary}
                className={clsx(
                  (location.pathname === item.href ||
                    item.childrenRoutes?.includes(location.pathname) ||
                    isHighlight(item.hightlightPaths, location.pathname)) &&
                    "text-text-secondary",
                )}
              >
                {item.text}
              </AppText>
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};
